import { defaultTechPresetValues } from "./index251.js";
import { TechSpacePresetTranslatorRulesLib } from "./index252.js";
function techSpacePreset2Props(props, defaultValues = defaultTechPresetValues) {
	const optionsRecord = props || defaultValues;
	const defaultRecord = defaultValues;
	for (const key in defaultRecord) if (optionsRecord[key] === void 0) optionsRecord[key] = defaultRecord[key];
	const options = optionsRecord;
	const deconstructedOptions = [];
	deconstructedOptions.push(options.energyGeneration);
	deconstructedOptions.push(options.powerRequirements);
	for (const key in options.extraOptions) if (options.extraOptions[key]) deconstructedOptions.push(key);
	const output = {
		forceInvalid: false,
		userDefinedAttributes: {},
		optionalSpaces: []
	};
	for (const option of deconstructedOptions) {
		const partialOutput = TechSpacePresetTranslatorRulesLib[option];
		if (partialOutput.forceInvalid) output.forceInvalid = partialOutput.forceInvalid;
		if (partialOutput.userDefinedAttributes) output.userDefinedAttributes = Object.assign(output.userDefinedAttributes, partialOutput.userDefinedAttributes);
		if (partialOutput.optionalSpaces) output.optionalSpaces.push(...partialOutput.optionalSpaces);
	}
	return output;
}
export { techSpacePreset2Props };

//# sourceMappingURL=index253.js.map